import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-left_angle",
  "use": "icon-left_angle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-left_angle\"><defs><style type=\"text/css\"></style></defs><path d=\"M737.9 947.7c15.6-15.6 15.6-40.9 0-56.6L358.8 512l379.1-379.1c15.6-15.6 15.6-40.9 0-56.6s-40.9-15.6-56.6 0L294.7 462.9c-13.5 13.5-20.3 31.3-20.3 49.1s6.8 35.6 20.3 49.1l386.6 386.6c15.6 15.6 41 15.6 56.6 0z\" p-id=\"6400\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol